type Props = {
  planPrepCourseIds: string[];
  planAddonCourseIds: string[];
  planOdtCourseIds: string[];
  planFundamentalCourseIds: string[];

  storedAtpCourseIds: string[];
  storedOptionalCourseIds: string[];
  storedOdtCourseIds: string[];
  storedFundamentalCourseIds: string[];
};

export const sanitizeCourseIds = ({
  planPrepCourseIds,
  planAddonCourseIds,
  planOdtCourseIds,
  planFundamentalCourseIds,

  storedAtpCourseIds,
  storedOptionalCourseIds,
  storedOdtCourseIds,
  storedFundamentalCourseIds,
}: Props) => {
  const selectedPrepCourseIds = storedAtpCourseIds?.filter((cid) => planPrepCourseIds.includes(cid)) ?? [];
  const selectedAddonCourseIds = storedOptionalCourseIds?.filter((cid) => planAddonCourseIds.includes(cid)) ?? [];
  const selectedOdtCourseIds = storedOdtCourseIds?.filter((cid) => planOdtCourseIds.includes(cid)) ?? [];
  const selectedFundamentalCourseIds =
    storedFundamentalCourseIds?.filter((cid) => planFundamentalCourseIds.includes(cid)) ?? [];

  return { selectedPrepCourseIds, selectedAddonCourseIds, selectedOdtCourseIds, selectedFundamentalCourseIds };
};
